import Pagination from "./Pagination";
import React, { useEffect, useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { useHistory, useLocation } from "react-router-dom";
import { TokenContext } from "./TokenContext";
import Repo from "../Utility/Repo";
import ModalComponent from "./ModalComponent";
import Badge from "./Badge";
import UserDataComponent from "./UserDataComponent";
import IO from "../Assets/Img/IO.svg";

const ListPaymemtsUsers = (props) => {
  const [showFileToggle, toggleModalShowFile] = useState(false);
  const [showModalDetail, setShowModalDetail] = useState(false);
  const [showModalMail, setShowModalMail] = useState(false);
  const [showModalIO, setShowModalIO] = useState(false);
  const [selectedIUV, setSelectedIUV] = useState("");

  const [pagamentoId, setPagamentoId] = useState("");
  const [showModalDelete, setShowModalDelete] = useState(false);
  const apiToken = useContext(TokenContext);
  const [file, setFile] = useState();
  const [hasMail, setHasMail] = useState(false);

  let history = useHistory();
  const { operator, userData, delegate, user, citizen } = UserDataComponent();

  const [formData, setFormData] = useState({
    iuv: "", // Se id esiste, assegnalo a formData.iuv, altrimenti assegna una stringa vuota
    descrizione: "",
    valore: 0,
  });

  const isMobile = () =>
    /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent);

  const [error, setError] = useState("");

  const toggleModalDetail = () => {
    setShowModalDetail(!showModalDetail);
    // Azzeramento dei campi qui
    setFormData({
      iuv: "", // Assegna il valore di id se disponibile, altrimenti stringa vuota
      descrizione: "",
      valore: 0, // Reset valore
    });
    setError("");
  };

  const toggleModalMail = () => {
    setShowModalMail(!showModalMail);
    // Azzeramento dei campi qui
    setError("");
  };

  const toggleModalIO = () => {
    setShowModalIO(!showModalIO);
    // Azzeramento dei campi qui
    setError("");
  };

  const handleDelete = () => {
    const data = {
      stringa: formData.descrizione,
    };

    Repo.delPosizioneDebitoria(apiToken, pagamentoId, data)
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        setError(error.response?.data?.Message || error.response?.data || "");
      });
  };

  const bodyDelete = () => {
    return (
      <>
        <div className="row mb-lg-3">
          Vuoi davvero eliminare il pagamento {selectedIUV}?
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div>
              <label htmlFor="descrizione">Descrizione:</label>
              <textarea
                id="descrizione"
                name="descrizione"
                value={formData.descrizione}
                onChange={handleChange}
              ></textarea>
            </div>

            <div className="d-flex justify-content-end">
              {!error && (
                <button
                  className="btn btn-danger"
                  type="button"
                  onClick={() => handleDelete()}
                >
                  Elimina pagamento
                </button>
              )}
            </div>
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione.</b> {error}".
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const showPayments = (id) => {
    if (isMobile()) {
      showPaymentsMobile(id);
      return;
    }

    Repo.getIuvUser(apiToken, id, true)
      .then((response) => {
        if (response.status === 200) {
          setFile();
          const obj = document.createElement("object");
          obj.type = "application/pdf";
          obj.data = "data:application/pdf;base64," + response.data;
          setFile(obj);
          toggleModalShowFile(!showFileToggle);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const showPaymentsMobile = (id) => {
    Repo.getIuvUser(apiToken, id, true)
      .then((response) => {
        if (response.status === 200) {
          const byteCharacters = atob(response.data);
          const byteNumbers = new Array(byteCharacters.length);
          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);

          // Apri una nuova finestra o tab (su mobile può aprirsi nel visualizzatore PDF di default)
          window.open(blobUrl, "_blank");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleSaveSendMail = () => {
    Repo.postSendEmail(apiToken, selectedIUV, props.userId)
      .then((response) => {
        if (response.status == 200) {
          setShowModalDetail(false);
          setSelectedIUV("");
          window.location.reload();
        }
      })
      .catch((error) => {
        setError(error.response?.data?.Message || error.response?.data || "");
      });
    // Resetta l'errore
    setError("");
  };

  const handleSaveSendIO = () => {
    Repo.postSendIO(apiToken, selectedIUV, props.userId)
      .then((response) => {
        if (response.status == 200) {
          setShowModalIO(false);
          setSelectedIUV("");
          window.location.reload();
        }
      })
      .catch((error) => {
        console.error(error);
        setError(error.response?.data?.Message || error.response?.data || "");
      });
    // Resetta l'errore
    setError("");
  };

  const handleSave = () => {
    //alert(formData.Iuv);
    // Effettua la validazione dei dati
    if (!formData.descrizione) {
      setError("Il campo descrizione è obbligatorio!");
      return;
    }

    if (formData.descrizione.length > 300) {
      setError("Il campo Descrizione deve essere massimo 300 caratteri!");
      return;
    }

    setFormData({
      iuv: selectedIUV,
      descrizione: formData.descrizione,
      valore: formData.valore,
    });
    const data = {
      iuv: selectedIUV,
      descrizione: formData.descrizione,
      valore: formData.valore,
    };

    Repo.poutUpdatePaidOp(apiToken, data)
      .then((response) => {
        if (response.status == 200) {
          setShowModalDetail(false);
          setSelectedIUV("");
          window.location.reload();
        }
      })
      .catch((error) => {
        setError(error.response?.data?.Message || error.response?.data || "");
      });

    // Resetta i valori del form dopo il salvataggio
    setFormData({
      iuv: "",
      descrizione: "",
    });

    // Resetta l'errore
    setError("");
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prevData) => ({
      ...prevData,
      [name]: name === "valore" ? value : value, // Mantieni "valore" come stringa
    }));
  };

  const bodyFile = () => {
    return (
      <object
        width="100%"
        height="900"
        data={file && file.data}
        type={file && file.type}
      ></object>
    );
  };

  const showDetail = (id) => {
    setSelectedIUV(id);
    setShowModalDetail(true);
  };

  const sendPayments = (id) => {
    setSelectedIUV(id);
    setShowModalMail(true);
  };

  const sendIO = (IUV) => {
    setSelectedIUV(IUV);
    setShowModalIO(true);
  };

  const handleCloseModal = () => {
    setFormData({
      iuv: "",
      descrizione: "",
    });
    setShowModalDetail(false);
  };

  const bodyDetail = (id) => {
    return (
      <>
        <div className="row mb-lg-3">
          In seguito potrai verificare lo stato del flusso dalla sezione 'Flussi
          MyPay' {id}
        </div>

        <div className="row">
          <input type="hidden" id="Iuv" name="Iuv" value={id} readOnly />

          <div className="col-lg-6">
            <p>
              Inserendo il valore <strong>0</strong> il pagamento verrà
              eliminato!
            </p>
          </div>
          <div className="col-lg-6">
            <label htmlFor="valore">
              Cambia importo
              <input
                id="valore"
                name="valore"
                type="number"
                step="0.01" // Permette i decimali
                value={formData.valore ?? 0} // Imposta un valore numerico di default
                onChange={(e) => {
                  const newValue = e.target.value;
                  if (newValue === "") {
                    setFormData({ ...formData, valore: null }); // Usa null se vuoto
                  } else {
                    setFormData({ ...formData, valore: parseFloat(newValue) });
                  }
                }}
              />
            </label>
          </div>
          <div className="col-lg-12">
            <div>
              <label htmlFor="descrizione">Descrizione:</label>
              <textarea
                id="descrizione"
                name="descrizione"
                value={formData.descrizione}
                onChange={handleChange}
              ></textarea>
            </div>

            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione.</b> {error}".
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const handleCloseModalMail = () => {
    setShowModalMail(false);
  };

  const bodyMail = (id) => {
    return (
      <>
        <div className="row mb-lg-3">
          Premendo Invia Email, il cittadino riceverà il bollettino PagoPa. Solo
          chi ha fornito un'email registrata riceverà la comunicazione.{" "}
          {props.userId}
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div>
              <label htmlFor="Iuv">Iuv:</label>
              <input type="text" id="Iuv" name="Iuv" value={id} readOnly />
            </div>
            <div></div>
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione.</b> {error}".
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  const bodyIO = (iuv) => {
    return (
      <>
        <div className="row mb-lg-3">
          Premendo Invia IO, il cittadino riceverà una notifica sull'App IO con
          pagamento PagoPA. Solo chi l'app installata sul device riceverà la
          notiifca. {props.userId}
        </div>

        <div className="row">
          <div className="col-lg-12">
            <div>
              <label htmlFor="Iuv">Iuv:</label>
              <input type="text" id="Iuv" name="Iuv" value={iuv} readOnly />
            </div>
            <div></div>
            {error && (
              <div className="alert alert-danger mt-2" role="alert">
                <b>Attenzione.</b> {error}".
              </div>
            )}
          </div>
        </div>
      </>
    );
  };

  return (
    <>
      <div className="card-wrapper card-space">
        <div className="card card-bg card-big roundedCustom no-after">
          <div className="card-body">
            <div className="row mb-2">
              <div className="col-10">
                <h4>Pagamenti</h4>
              </div>
              {props.goBack && (
                <div className="col-2 text-right">
                  <button
                    className="btn btn-info"
                    onClick={() => history.goBack()}
                  >
                    <svg className="icon icon-white icon-sm">
                      <use href={`${iconSprite}#it-arrow-left`} />
                    </svg>
                    <span className="text-white">Indietro</span>
                  </button>
                </div>
              )}
            </div>

            {props.payments?.length > 0 ? (
              props.payments.map((x) => (
                <div
                  key={x.id}
                  className={`payment-card ${
                    x.stato != 0 ? "border-success" : "border-danger"
                  }`}
                >
                  <div className="row mt-4 ml-3">
                    <div className="col-12">{x.titolo || "Pagamento"} </div>
                    <div className="w-100 sl-h10"></div>

                    <div className="col-lg-5">
                      <div>
                        Importo dovuto:{" "}
                        <span className="fw-semibold">
                          <b>{x.importoDovuto?.toLocaleString("it-IT")} €</b>
                        </span>
                        {x?.ore?.trim() && x.ore.trim() !== "0" && (
                          <span>
                            &nbsp;<i>Ore: {x.ore}</i>
                          </span>
                        )}
                      </div>
                      <div>
                        Importo pagato:{" "}
                        <b>
                          {x.stato != 0 && x.importoTotalePagato
                            ? `${x.importoTotalePagato?.toLocaleString(
                                "it-IT"
                              )} €`
                            : "0 €"}
                        </b>
                      </div>
                      {!citizen && x?.descrizione && (
                        <span className="badge bg-primary text-white">
                          {x.descrizione}
                        </span>
                      )}
                    </div>

                    <div className="col-lg-4 col-md-3 mb-3">
                      <Badge
                        badgeStatus={
                          (x.stato != 0 && x.importoTotalePagato === 0) ||
                          x.stato == 2
                            ? "bg-danger"
                            : x.stato != 0
                            ? "bg-success"
                            : "bg-primary"
                        }
                        badgeText={
                          (x.stato != 0 && x.importoTotalePagato === 0) ||
                          x.stato == 2
                            ? "Annullato"
                            : x.stato != 0
                            ? "Pagato"
                            : "Da pagare"
                        }
                        title={x?.dataEsitoSingoloPagamento}
                      />
                      <Badge
                        badgeStatus={x.isEmailSent ? "bg-success" : "bg-danger"}
                        badgeText={
                          x.isEmailSent ? "Email inviata" : "Email non inviata"
                        }
                        title={x?.dataIsEmailSent}
                      />

                      <Badge
                        badgeStatus={
                          x.ioId && x.ioId !== "-1" ? "bg-success" : "bg-danger"
                        }
                        badgeText={x.ioId ? "IO inviata" : "IO non inviata"}
                      />

                      <div className="shadow-sm  bg-white">
                        IUV: <strong>{x.codIuv}</strong>{" "}
                      </div>
                    </div>

                    <div className="col text-right">
                      {x.stato != 0 ? (
                        <>
                          <button
                            className="btn btn-outline-primary p-2 mr-2"
                            onClick={() => showPayments(x.codIuv)}
                            aria-label="Visualizza"
                            title="Visualizza"
                          >
                            <svg className="icon icon-primary">
                              <use href={`${iconSprite}#it-file`} />
                            </svg>
                          </button>
                        </>
                      ) : (
                        <>
                          {!citizen && (
                            <>
                              <button
                                className="btn btn-outline-primary p-2 mr-2"
                                onClick={() => sendIO(x.codIuv)}
                                disabled={delegate}
                                title={`IO ${x.ioId}`}
                              >
                                <img
                                  src={IO}
                                  alt={`${x.ioId ? x.ioId : "Invia su App IO"}`}
                                  className="img-io"
                                />
                              </button>

                              <button
                                className="btn btn-outline-primary p-2 mr-2"
                                onClick={() => showPayments(x.codIuv)}
                                aria-label="Visualizza"
                                title="Visualizza"
                              >
                                <svg className="icon icon-primary">
                                  <use href={`${iconSprite}#it-file`} />
                                </svg>
                              </button>
                            </>
                          )}

                          <button
                            className="btn btn-outline-primary p-2"
                            onClick={() => sendPayments(x.codIuv)}
                            title="Invia email"
                          >
                            <svg className="icon icon-primary">
                              <use href={`${iconSprite}#it-mail`} />
                            </svg>
                          </button>
                          <button
                            className="btn btn-outline-danger p-2 ml-2"
                            onClick={() => {
                              setShowModalDelete(true),
                                setSelectedIUV(x.codIuv),
                                setPagamentoId(x.id);
                            }}
                            title="Annulla pagamento"
                          >
                            <svg className="icon icon-danger">
                              <use href={`${iconSprite}#it-delete`} />
                            </svg>
                          </button>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <>Non ci sono pagamenti</>
            )}

            {props.paymentsTemp && (
              <Pagination
                items={props.paymentsTemp}
                setCurrentItems={props.setPayments}
                itemsPerPage={15}
              />
            )}
          </div>
        </div>
      </div>

      <ModalComponent
        toggleModal={() => toggleModalShowFile(!showFileToggle)}
        isOpen={showFileToggle}
        header="File"
        body={bodyFile()}
        buttonDeny="Chiudi"
      />

      <ModalComponent
        toggleModal={toggleModalDetail}
        isOpen={showModalDetail}
        header="Dettagli"
        body={bodyDetail(selectedIUV)}
        buttonDeny="Annulla"
        buttonConfirm="Conferma"
        function={handleSave}
        onClose={handleCloseModal}
      />

      <ModalComponent
        labelledBy="modalEmail"
        toggleModal={toggleModalMail}
        isOpen={showModalMail}
        header="Invia email con il bollettino"
        body={bodyMail(selectedIUV)}
        buttonConfirm="Invia email"
        buttonDeny="Annulla"
        function={handleSaveSendMail}
      />

      <ModalComponent
        labelledBy="modalIO"
        toggleModal={toggleModalIO}
        isOpen={showModalIO}
        header="Invia Notifica IO"
        body={bodyIO(selectedIUV)}
        buttonConfirm="Invia notifica IO"
        buttonDeny="Annulla"
        function={handleSaveSendIO}
      />

      <ModalComponent
        toggleModal={setShowModalDelete}
        isOpen={showModalDelete}
        header="Annulla pagamento"
        body={bodyDelete(selectedIUV)}
        buttonDeny="Chiudi"
        onClose={handleCloseModal}
      />
    </>
  );
};

export default ListPaymemtsUsers;
